import { useTranslation } from 'react-i18next'
import * as Yup from 'yup'

export const useSchema = () => {
  const { t } = useTranslation()

  const skierSchema = Yup.object().shape({
    name: Yup.string().required(t('general.validation.required')).max(255),
    age: Yup.number()
      .transform((value, original) => (original === '' ? undefined : value))
      .required(t('general.validation.required'))
      .min(0)
      .integer(),
  })

  const bookingEntrySchema = Yup.object().shape({
    customerId: Yup.string().required(t('general.validation.required')),
    clientName: Yup.string().optional().default(''),
    skiers: Yup.array().of(skierSchema).min(1).required(),
  })

  return Yup.object().shape({
    date: Yup.string().required(),
    startTime: Yup.string().required(t('general.validation.required')),
    endTime: Yup.string()
      .required(t('general.validation.required'))
      .test('after-start', t('general.validation.endTimeAfterStart'), function (value) {
        const { startTime } = this.parent
        if (!value || !startTime) return true
        return value > startTime
      }),
    instructorIds: Yup.array().of(Yup.string().required()).default([]),
    productId: Yup.string().required(),
    customerId: Yup.string().optional().default(''),
    clientName: Yup.string().optional().default(''),
    skiers: Yup.array().of(skierSchema).default([]),
    bookings: Yup.array().of(bookingEntrySchema).default([]),
    notes: Yup.string().optional().default(''),
  })
}

export type LessonFormValues = Yup.InferType<ReturnType<typeof useSchema>>
